import styled from 'styled-components'
import { ReactComponent as ErrorFile } from 'core/assets/images/error-file.svg'
import { ReactComponent as ErrorImage } from 'core/assets/images/error-image.svg'

const Container = styled.div`
  position: absolute;
  text-align: center;
  background-color: #ffffff8a;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-content: center;
  text-align: center;
`

const ErrorImageSvg = styled(ErrorImage)`
  width: 62.25px;
  height: 62.25px;
`

const ErrorFileSvg = styled(ErrorFile)`
  width: 400px;
  height: 100%;
`

const StyledError = styled.div`
  color: ${props => props.theme.palette.error.main};
  font-size: 14px;
`

const FileName = styled.div`
  font-size: 12px;
  color: ${props => props.theme.palette.grey[600]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-items: center;
  padding: 2px 10px;
`
export { Container, StyledError, FileName, ErrorImageSvg, ErrorFileSvg }
